
// Scrollbar Start
class SliderScrollbar {
  constructor(slider) {
    this.slider = slider;
    this.isMobile = window.matchMedia('(max-width: 767px)').matches;
    this.init();
    window.addEventListener('resize', () => this.handleResize());
  }

  handleResize() {
    const newIsMobile = window.matchMedia('(max-width: 767px)').matches;
    if (newIsMobile !== this.isMobile) {
      this.isMobile = newIsMobile;
      this.recreateScrollbar();
    }
  }

  recreateScrollbar() {
    const existing = this.slider.parentNode.querySelector('.scrollbar-wrapper');
    if (existing) existing.remove();
    this.createScrollbar();
  }

  init() {
    this.createScrollbar();
  }

  createScrollbar() {
    const scrollbarWrap = document.createElement('div');
    scrollbarWrap.className = 'scrollbar-wrapper';

    const scrollbar = document.createElement('div');
    scrollbar.className = 'slider-scrollbar';

    const thumb = document.createElement('div');
    thumb.className = 'slider-scrollbar__thumb';

    scrollbar.appendChild(thumb);
    scrollbarWrap.appendChild(scrollbar);

    this.slider.parentNode.insertBefore(scrollbarWrap, this.slider.nextSibling);

    // Update thumb on scroll
    this.slider.addEventListener('scroll', () => {
      this.updateThumb(thumb);
    });

    // Click anywhere on scrollbar to jump
    scrollbar.addEventListener('click', (e) => {
      this.handleScrollbarClick(e, scrollbar);
    });

    this.updateThumb(thumb);
  }

  updateThumb(thumb) {
    const maxScroll = this.slider.scrollWidth - this.slider.clientWidth;
    
    if (maxScroll <= 0) {
      thumb.style.width = "100%";
      thumb.style.left = "0%";
      return;
    }

    // Calculate thumb width (proportional to visible area)
    const thumbWidth = (this.slider.clientWidth / this.slider.scrollWidth) * 100;
    thumb.style.width = `${Math.max(10, thumbWidth)}%`; // Minimum 10% width

    // Calculate thumb position
    const scrollRatio = this.slider.scrollLeft / maxScroll;
    const maxThumbPosition = 100 - thumbWidth;
    const thumbPosition = scrollRatio * maxThumbPosition;
    
    thumb.style.left = `${thumbPosition}%`;
  }

  handleScrollbarClick(e, scrollbar) {
    const rect = scrollbar.getBoundingClientRect();
    const clickRatio = (e.clientX - rect.left) / rect.width;
    const maxScroll = this.slider.scrollWidth - this.slider.clientWidth;
    
    this.slider.scrollTo({
      left: clickRatio * maxScroll,
      behavior: 'smooth'
    });
  }
}

function initCustomScrollbars(context = document) {
  context.querySelectorAll('.grid--slider[data-custom-dots="true"], .grid--mobile-slider[data-custom-dots="true"]').forEach((el) => {
    if (!el.dataset.sliderInit) {
      new SliderScrollbar(el);
      el.dataset.sliderInit = "true";
    }
  });
}

document.addEventListener("DOMContentLoaded", () => {
  initCustomScrollbars();

  setTimeout(() => {
    const recentProductsSection = document.querySelector('.recent__content[data-grid-slider]');
    if (recentProductsSection) {
      initCustomScrollbars();
      console.log("Reinit recommended section!");
    }
  }, 2000);
});

document.addEventListener("shopify:section:load", (e) => {
  initCustomScrollbars(e.target);
});
// end Scrollbar


// Upsell flickity Slider
// let flkty;

// document.addEventListener('DOMContentLoaded', () => {
//   const slider = document.querySelector('.product-list-upsell-slider');
//   if (!slider) return;

//   flkty = new Flickity(slider, {
//     wrapAround: true,
//     pageDots: false,
//     prevNextButtons: false,
//     cellAlign: 'left',
//     cellSelector: 'quick-add-product'
//   });

//   document.querySelector('.flickity-prev')?.addEventListener('click', () => flkty.previous());
//   document.querySelector('.flickity-next')?.addEventListener('click', () => flkty.next());
// });

// document.querySelectorAll('.hide_upsell-product').forEach(button => {
//   button.addEventListener('click', function(e) {
//     e.preventDefault();
//     const quickAdd = this.closest('quick-add-product');
//     const upsellBlock = this.closest('.cart-block-upsell');
//     if (!quickAdd || !flkty || !upsellBlock) return;

//     flkty.remove(quickAdd);
    
//     if (flkty.cells.length === 0) {
//       upsellBlock.style.display = 'none';
//     }
    
//     flkty.resize();
//   });
// });


// Product page image zoom feature

// const zoomContainers = document.querySelectorAll('product-images .product__slides .product__slide .image-wrapper');

// if(zoomContainers){
//    zoomContainers.forEach((container) => {
//     const img = container.querySelector('img');
  
//     container.addEventListener('mousemove', (e) => {
//       container.style.cursor = "crosshair";
//       const rect = container.getBoundingClientRect();
//       const x = e.clientX - rect.left;
//       const y = e.clientY - rect.top;
      
//       img.style.transformOrigin = `${x}px ${y}px`;
//       img.style.transform = 'scale(2)';
//     });
  
//     container.addEventListener('mouseleave', () => {
//       container.style.cursor = "default";
//       img.style.transform = 'scale(1)';
//     });
//   }); 
// }

(function() {
// Select all elements with the 'data-header-expanded' attribute
const headerElements = document.querySelectorAll('[data-header-expanded]');
const mainHeader = document.querySelector('header')
  
// Function to update the attribute based on scroll position
function updateHeaderExpanded() {
    const isAtTop = window.scrollY === 0;

    headerElements.forEach(headerElement => {
        if (isAtTop) {
            headerElement.setAttribute('data-header-expanded', 'true');
          
        } else {
            headerElement.setAttribute('data-header-expanded', 'false');
        }
    });
}
//Check for Homepage
const isHP = () => {
  const currentURL = window.location.origin + window.location.pathname;
  const baseURL = window.location.origin + '/';

  console.log(currentURL, baseURL)
  return currentURL === baseURL;
}

if(isHP()) {
//Applies styles only when on HP
mainHeader.classList.add('animate-header')
// Add event listener to update on scroll
window.addEventListener('scroll', updateHeaderExpanded);

// Initial check in case the page is not loaded at the top
updateHeaderExpanded();
  
}  



// PDP Desc Read more Logic
  document.addEventListener("DOMContentLoaded", function () {
  const readMore = document.getElementById("read-more");
  const readLess = document.getElementById("read-less");
  const truncated = document.getElementById("truncated-description");
  const full = document.getElementById("full-description");

  if (readMore && readLess && truncated && full) {
    readMore.addEventListener("click", function () {
      truncated.style.display = "none";
      full.style.display = "block";
    });

    readLess.addEventListener("click", function () {
      full.style.display = "none";
      truncated.style.display = "block";
    });
  }
});
  



  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();



document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".sliderow__title").forEach(function (title) {
    title.addEventListener("click", function () {
      const wrapper = this.closest(".sliderow-wrap");
      if (wrapper) {
        wrapper.classList.toggle("open");
      }
    });
  });
});






//Upsell

const removedUpsellCards = new Map();

function getUpsellProductId(card) {
  const holder = card.querySelector('[data-quick-add-holder]');
  return holder ? Number(holder.dataset.quickAddHolder) : null;
}

function reinitUpsellSlider(upsellBlock) {
  const gridSlider = upsellBlock.querySelector('grid-slider');
  if (!gridSlider) return;

  window.gridSlider = gridSlider; 

  const sliderEl = upsellBlock.querySelector('[data-grid-slider]');
  if (!sliderEl) return;

  const existing = upsellBlock.querySelector('.scrollbar-wrapper');
  if (existing) existing.remove();

  sliderEl.dataset.sliderInit = "";

  const items = sliderEl.querySelectorAll('quick-add-product');

  if (items.length <= 1) {
    return;
  }

  requestAnimationFrame(() => {
    gridSlider.dispatchEvent(new CustomEvent('theme:grid-slider:init'));
    initCustomScrollbars(upsellBlock);
  });
}

function removeUpsellCard(card) {
  const productId = getUpsellProductId(card);
  if (productId) removedUpsellCards.set(productId, card);
  card.remove();
}

async function syncUpsellWithCart() {
  console.log("syncUpsellWithCart");
  
  const upsellBlock = document.querySelector('.cart-block-upsell');
  if (!upsellBlock) return;

  try {
    const res = await fetch('/cart.js');
    if (!res.ok) return;

    const cart = await res.json();
    const cartProductIds = cart.items.map(item => item.product_id);

    upsellBlock.querySelectorAll('quick-add-product').forEach(card => {
      const productId = getUpsellProductId(card);
      if (productId && cartProductIds.includes(productId)) {
        removeUpsellCard(card);
      }
    });

    const slideContainer =
      upsellBlock.querySelector('[data-grid-slider]') || upsellBlock;

    removedUpsellCards.forEach(function (card, productId) {
      if (cartProductIds.indexOf(productId) === -1) {
        slideContainer.appendChild(card);
        removedUpsellCards.delete(productId);
      }
    });

    reinitUpsellSlider(upsellBlock);
  } catch (error) {
    console.error('Upsell sync error:', error);
  }
}

document.addEventListener('theme:product:add', (e) => {
  const button = e.detail?.button;
  if (!button) return;

  const quickAddProduct = button.closest('quick-add-product');
  if (!quickAddProduct) return;

  const upsellBlock = quickAddProduct.closest('.cart-block-upsell');
  if (!upsellBlock) return;

  removeUpsellCard(quickAddProduct);
  reinitUpsellSlider(upsellBlock);
});

document.addEventListener('theme:cart:change', syncUpsellWithCart);
document.addEventListener('theme:cart-drawer:open', syncUpsellWithCart);


// Video mute logic
function muteButton () {
  
  const toggleButtons = document.querySelectorAll('.video-mute-toggle');
  
  toggleButtons.forEach((button) => {
    // Prevent Flickity drag capture
    button.addEventListener('pointerdown', e => e.stopPropagation());
    button.addEventListener('touchstart', e => e.stopPropagation());
    
    button.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      console.log("clicked");
      
      
      const videoId = this.dataset.videoId;
      const video = document.getElementById(videoId);
      if (!video) return;
      
      video.muted = !video.muted;
      this.classList.toggle('is-muted', video.muted);
    });
  });
}

document.addEventListener("DOMContentLoaded", muteButton);
document.addEventListener("shopify:section:load", muteButton);



// Grid Swatches

function initGridItemSwatches(context = document) {
    context.querySelectorAll('[data-grid-item]').forEach((card) => {
        if (card.dataset.swatchInit) return;

        const swatches = card.querySelectorAll('[data-variant-url]');
        if (!swatches.length) return;

        card.dataset.swatchInit = 'true';

        const links = card.querySelectorAll('[data-product-link]');

        swatches.forEach((swatch) => {
            swatch.addEventListener('click', (event) => {
                event.preventDefault();

                const variantUrl = swatch.dataset.variantUrl;
                if (!variantUrl) return;

                swatches.forEach((el) => {
                    el.classList.toggle('swatch__button--current', el === swatch);
                });

                const variantId = swatch.dataset.variantId;
                if (variantId) {
                    card.querySelectorAll('[data-variant-id]').forEach((image) => {
                        image.classList.toggle('is-visible', image.dataset.variantId === variantId);
                    });
                }

                links.forEach((link) => {
                    link.setAttribute('href', variantUrl);
                    link.dataset.productLink = variantUrl;
                });
            });
        });
    });
}

document.addEventListener('DOMContentLoaded', () => initGridItemSwatches());
document.addEventListener('shopify:section:load', (e) => initGridItemSwatches(e.target));
document.addEventListener('paginate:collections-loaded', (e) => initGridItemSwatches());




// On page load scroll to active variant media
document.addEventListener('DOMContentLoaded', function() {
    if (!new URLSearchParams(window.location.search).has('variant')) return;

    const activeMedia = document.querySelector('[data-default-v-media]');
    if (!activeMedia) return;

    window.addEventListener('load', function() {
        const stickyHeader = document.querySelector('[data-header-sticky]');
        const headerHeight = stickyHeader ? (document.querySelector('[data-header-height]')?.offsetHeight || 0) : 0;

        window.scrollTo({
            top: activeMedia.getBoundingClientRect().top + window.scrollY - headerHeight,
            behavior: 'smooth',
        });
    });
});